"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const DeliverySettingAddress_1 = require("@/common/components/DeliverySetting/DeliverySettingAddress");
function default_1({ hasMaximumAddressList, enableAddNewAddress, }) {
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onAddNewAddressClick = () => {
        if (hasMaximumAddressList) {
            confirm({
                description: DeliverySettingAddress_1.addressErrorMessages.list_limit(),
                cancellationButtonProps: { style: { display: 'none' } },
            });
        }
        else {
            enableAddNewAddress();
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-table-row" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: { padding: '16px 14px', marginBottom: '10px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onAddNewAddressClick, sx: {
                    height: '32px',
                    p: '0 12px',
                    borderRadius: '6px',
                    border: '1px solid var(--gray-80)',
                    color: 'var(--gray-80)',
                    bgcolor: 'var(--white) !important',
                } }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('새 주소 추가')] })) })) })) })));
}
exports.default = default_1;
